import { Section } from 'tio-ui/components/layout';
import { t } from 'ember-intl';
import Component from '@glimmer/component';
import StackedList from 'tio-ui/components/stacked-list';
import type { ListItem } from 'tio-ui/components/stacked-list';
import type { TasProgramTemplateExtension as TASProgramTemplateModel } from 'tio-data/data/resources/tas-program-template.ext';

export interface TasFaqsSignature {
  Args: {
    template: TASProgramTemplateModel;
  };
  Element: HTMLDivElement;
}

export default class TasFaqs extends Component<TasFaqsSignature> {
  get faqItems() {
    return this.args.template.programFaqs.map((faq) => ({
      heading: faq.heading,
      body: faq.body,
      ordinal: faq.ordinal,
    })) as ListItem[];
  }
  <template>
    {{#if this.faqItems}}
      <Section>
        <:header>
          {{t "tuition_assistance.faq"}}
        </:header>
        <:body>
          <StackedList @items={{this.faqItems}} @isExpandable={{true}} />
        </:body>
      </Section>
    {{/if}}
  </template>
}
